<template>
<ul class="kt-nav" :class="_class">
    <slot></slot>
</ul>  
</template>

<script>
import $ from 'jquery'

$('.kt-nav__link').each(function(item, el) {
    if(el.href === window.location.href) {
        $(el.parentElement).addClass('active');
    }
});

export default {
    props: ['size', 'space'],
    computed: {
        _class: function() {
            let _class= []

            if(this.size) {
                _class.push('kt-nav--'+this.size+'-font')
            }

            if(this.space) {
                _class.push('kt-nav--'+this.space+'-space')
            }

            return _class
        }
    }
}
</script>